import { post, get, formPost, formGet } from "../Http";
import { financeBasicLv, financeBasicQzc } from "../config";

//枚举类型
function findByCategoryId(params) {
    return post(`/${financeBasicLv}/basicenum/findByCategoryId`, params)
}
//枚举国家
function basiccountryQueryAll(params) {
    return post(`/${financeBasicLv}/basiccountry/queryAll`, params)
}

//部门枚举
function basicdepartmentFindList(params) {
    return get(`/${financeBasicQzc}/basicdepartment/findList`, params)
}
//上级项目枚举
function basicprojectfindAll(params) {
    return post(`/${financeBasicQzc}/basicproject/findAll`, params)
}
//计量单位枚举
function basicunitQueryAll(params) {
    return post(`/${financeBasicLv}/basicunit/queryAll`, params)
}
//查询税收分类 大小类列表
function queryTaxByParentId(params) {
    return post(`/${financeBasicLv}/basictaxclass/queryTaxByParentId`, params)
}
//查询税收分类树状
function TaxList(params) {
    return get(`/${financeBasicLv}/basictaxclass/queryAbbTree`, params)
}
//上级项目枚举
function basicprojectFindTree(params) {
    return get(`/${financeBasicQzc}/basicproject/findTree`)
}
//供应商列表
function basicsupplierList(params) {
    return post(`/${financeBasicLv}/basicsupplier/list`, params)
}
//供应商删除
function basicsupplierDelete(params) {
    return post(`/${financeBasicLv}/basicsupplier/deleteBatch`, params)
}
//供应商新增更新
function basicsupplierSave(params) {
    return post(`/${financeBasicLv}/basicsupplier/save`, params)
}
//供应商导出
function basicsupplierExport() {
    return post(`/${financeBasicLv}/basicsupplier/export`, {}, { responseType: 'blob' })
}
//供应商列表
// function basicsupplierList(params){
//     return post(`/${financeBasicLv}/basicsupplier/list`,params)
// }
//供应商分类列表
function basicSupplierTypeList(params) {
    return post(`/${financeBasicLv}/basicSupplierType/list`, params)
}
//供应商分类新增
function basicSupplierTypeSave(params) {
    return post(`/${financeBasicLv}/basicSupplierType/save`, params)
}
//供应商分类删除
function basicSupplierTypeDelete(params) {
    return post(`/${financeBasicLv}/basicSupplierType/delete`, params)
}
//客户列表
function basiccustomerList(params) {
    return post(`/${financeBasicLv}/basiccustomer/list`, params)
}
//客户不分页列表
function basiccustomerFindList() {
    return post(`/${financeBasicLv}/basiccustomer/findList`, {})
}
//客户删除
function basiccustomerDelete(params) {
    return post(`/${financeBasicLv}/basiccustomer/deleteBatch`, params)
}
//客户新增更新
function basiccustomerSave(params) {
    return post(`/${financeBasicLv}/basiccustomer/save`, params)
}
//客户导出
function basiccustomerExport() {
    return post(`/${financeBasicLv}/basiccustomer/export`, {}, { responseType: 'blob' })
}
//客户分类列表
function basicCustomerTypeList(params) {
    return post(`/${financeBasicLv}/basicCustomerType/list`, params)
}
//客户分类新增
function basicCustomerTypeSave(params) {
    return post(`/${financeBasicLv}/basicCustomerType/save`, params)
}
//客户分类删除
function basicCustomerTypeDelete(params) {
    return post(`/${financeBasicLv}/basicCustomerType/delete`, params)
}
//部门列表
function basicdepartmentList(params) {
    return post(`/${financeBasicLv}/basicdepartment/list`, params)
}
//部门删除多删
function basicdepartmentDeleteAll(params) {
    return post(`/${financeBasicLv}/basicdepartment/deleteBatch`, params)
}
//部门删除单删
function basicdepartmentDelete(params) {
    return post(`/${financeBasicLv}/basicdepartment/delete`, params)
}
//部门新增更新
function basicdepartmentSave(params) {
    return post(`/${financeBasicLv}/basicdepartment/save`, params)
}
//部门导出
function basicdepartmentExport() {
    return post(`/${financeBasicLv}/basicdepartment/export`, {}, { responseType: 'blob' })
}
//职级类别列表
function basicPersonnelLevelQueryAll(params) {
    return post(`/${financeBasicLv}/basicPersonnelLevel/queryAll`, params)
}
//职级类别列表可用
function basicPersonnelLevelQueryAllEnabled(params) {
    return post(`/${financeBasicLv}/basicPersonnelLevel/queryAllEnabled`, params)
}
//职级类别修改
function basicPersonnelLevelSave(params) {
    return post(`/${financeBasicLv}/basicPersonnelLevel/save`, params)
}
//人员列表
function basicpersonnelList(params) {
    return post(`/${financeBasicLv}/basicpersonnel/list`, params)
}
//人员删除
function basicpersonnelDelete(params) {
    return post(`/${financeBasicLv}/basicpersonnel/deleteBatch`, params)
}
//人员下拉
function basicPersonnelSelect() {
    return post(`/${financeBasicLv}/basicpersonnel/findAll`, {})

}
//人员新增更新
function basicpersonnelSave(params) {
    return post(`/${financeBasicLv}/basicpersonnel/save`, params)
}
//人员导出
function basicpersonnelExport() {
    return post(`/${financeBasicLv}/basicpersonnel/export`, {}, { responseType: 'blob' })
}
//仓库列表
function storeList(params) {
    return post(`/${financeBasicLv}/basicstore/list`, params)
}
//仓库删除
function storeDelete(params) {
    return post(`/${financeBasicLv}/basicstore/deleteBatch`, params)
}
//仓库详情
function storeDetail(id) {
    return post(`/${financeBasicLv}/basicstore/getById`, { id: id })
}
//仓库新增
function storeSave(params) {
    return post(`/${financeBasicLv}/basicstore/save`, params)
}
//项目列表
function basicprojectList(params) {
    return post(`/${financeBasicQzc}/basicproject/list`, params)
}
//项目新增
function basicprojectSave(params) {
    return post(`/${financeBasicQzc}/basicproject/save`, params)
}
function basicprojectAll(params) {
    return post(`/${financeBasicQzc}/basicproject/findAll`, {})
}
//项目删除多删
function basicprojectDeleteAll(params) {
    return post(`/${financeBasicLv}/basicproject/deleteBatch`, params)
}
//项目删除单删
function basicprojectDelete(params) {
    return post(`/${financeBasicLv}/basicproject/delete`, params)
}
//项目导出
function basicprojectExport() {
    return post(`/${financeBasicQzc}/basicproject/export`, {}, { responseType: 'blob' })
}
//银行账号列表
function basicbankList(params) {
    return post(`/${financeBasicQzc}/basicbank/list`, params)
}
//银行账号保存/更新
function basicbanktSave(params) {
    return post(`/${financeBasicQzc}/basicbank/save`, params)
}
//银行账号删除
function basicbankDelete(params) {
    return post(`/${financeBasicLv}/basicbank/deleteBatch`, params)
}
// 全局科目

function accountList(params) {
    return post(`/${financeBasicLv}/basicsubject/queryAllByAbId`, params)
}
//账套科目
export function accountSubject(abId) {
    return get(`/api-finbasic/basicsubject/querySubjectList/${abId}`)

}
//科目管理详情
function accountDetail(params) {
    return post(`/${financeBasicLv}/basicsubject/getById`, params)
}
//科目保存
function accountSave(params) {
    return post(`/${financeBasicLv}/basicsubject/save`, params)
}
//科目删除
function accountDelete(params) {
    return post(`/${financeBasicLv}/basicsubject/delete`, params)
}

//存货列表
function basicinventoryList(params) {
    return post(`/${financeBasicLv}/basicinventory/list`, params)
}

// 存货不分页列表
function basicinventoryQueryAll(params) {
    return post(`/${financeBasicLv}/basicinventory/queryAll`, {})
}
//存货保存
function basicinventorySave(params) {
    return post(`/${financeBasicLv}/basicinventory/save`, params)
}
//存货删除
function basicinventoryDelete(params) {
    return post(`/${financeBasicLv}/basicinventory/deleteBatch`, params)
}
//科目编辑
function accountUpdate(params) {
    return post(`/${financeBasicLv}/basicsubject/update`, params)
}

//功能模块配置 列表
function accountServiceList() {
    return post(`/${financeBasicLv}/basicaccountbookservice/getByAbId`, {})
}
//功能模块配置   保存
function accountServiceSave(params) {
    return post(`/${financeBasicLv}/basicaccountbookservice/save`, params)
}
//同步科目
function syncSubject(params) {
    return post(`/${financeBasicLv}/basicsubject/synSubject`, params)
}
//仓库导出
function basicStoreExport() {
    return post(`/${financeBasicLv}/basicstore/export`, {}, { responseType: 'blob' })
}
//存货导出
function basicInventoryExport() {
    return post(`/${financeBasicLv}/basicinventory/export`, {}, { responseType: 'blob' })
}

//存货导出2
function basicInventoryExportExcel(params) {
    return formGet(`/${financeBasicLv}/basicinventory/exportExcel`, params)
}
//计量单位新增
function unitSave(params) {
    return post(`/${financeBasicQzc}/basicunit/save`, params)
}

//计量单位删除
function unitDelete(params) {
    return post(`/${financeBasicQzc}/basicunit/deleteBatch`, params)
}
// 计量单位列表
function unitList(params) {
    return post(`/${financeBasicQzc}/basicunit/list`, params)
}
//
function uniExport() {
    return post(`/${financeBasicQzc}/basicunit/export`, {}, { responseType: 'blob' })
}

//银行账号导出
function backExport() {
    return post(`/${financeBasicLv}/basicbank/export`, {}, { responseType: 'blob' })

}
//全部科目
export function subjectAllList(params) {
    return post(`/${financeBasicLv}/basicsubject/queryAllByAbId`, params)

}
//全部仓库
export function allStore() {
    return post(`/${financeBasicLv}/basicstore/findList`, {})

}
//全部部门
export function allDepartment() {
    return get(`/api-finbasic/basicdepartment/findList`, {})

}
//全部人员
export function allPersonnel() {
    return post(`/api-finbasic/basicpersonnel/findAll`, {})

}
//全部供应商
export function allSupplier() {
    return get(`/api-finbasic/basicsupplier/findList`, {})

}
//全部项目
export function allProject() {
    return post(`/api-finbasic/basicproject/findAll`, {})

}
//全部银行
export function allBank() {
    return post(`/api-finbasic/basicbank/findList`, {})

}

//账套配置保存
function accountConfigSave(params) {
    return post(`/${financeBasicQzc}/basicaccountbookconfigure/save`, params)
}

//查询商旅供应商
function basicList() {
    return get(`/${financeBasicQzc}/basicsupplier/findList`)
}
//配置详情
function accountConfigDetail(accountingStandards) {
    return get(`/${financeBasicQzc}/basicaccountbookconfigure/findByAbId?accountingStandards=${accountingStandards}`,)
}
//资产科目列表
function abconfigureassetList(params) {
    return post(`/api-finbasic/abconfigureasset/list`, params)
}
//资产科目更新
function abconfigureassetUpdate(params) {
    return post(`/api-finbasic/abconfigureasset/updateAsset`, params)
}
//薪资费用列表
function abconfiguresalaryList(params) {
    return post(`/api-finbasic/abconfiguresalary/list`, params)
}
//薪资费用更新
function abconfiguresalaryUpdate(params) {
    return post(`/api-finbasic/abconfiguresalary/updatesalary`, params)
}
// /
//科目配置同步
function subjectConfigSync(params) {
    return get(`/api-finbasic/basicaccountbookconfigure/configInit?accountingStandards=${params.accountingStandards}`,)
}

//平台导入
function uploadPlatform(type,url) {
    return post(`/api-finbasic/${type}/uploadPlatform`, url)
}

//模板账套修改账套编码
function markSave(params) {
    return post(`/api-finbasic/basicAccountBookInitExpand/save`, params)
}
//模板账套查询账套编码
function bookInitExpandAbId(abId) {
    return get(`/api-finbasic/basicAccountBookInitExpand/${abId}`,)
}

export default {
    markSave,
    bookInitExpandAbId,
    findByCategoryId,
    subjectConfigSync,
    uploadPlatform,
    accountSubject,
    abconfiguresalaryList,
    abconfiguresalaryUpdate,
    basicStoreExport,
    basiccountryQueryAll,
    basicdepartmentFindList,
    basicprojectfindAll,
    basicunitQueryAll,
    queryTaxByParentId,
    TaxList,
    basicprojectFindTree,
    basicsupplierList,
    basicsupplierDelete,
    basicsupplierSave,
    basicsupplierExport,
    basicSupplierTypeList,
    basicSupplierTypeSave,
    basicSupplierTypeDelete,
    basiccustomerList,
    basiccustomerFindList,
    basiccustomerDelete,
    basiccustomerSave,
    basiccustomerExport,
    basicCustomerTypeList,
    basicCustomerTypeSave,
    basicCustomerTypeDelete,
    basicdepartmentList,
    basicdepartmentDeleteAll,
    basicdepartmentDelete,
    basicdepartmentSave,
    basicdepartmentExport,
    basicPersonnelLevelQueryAll,
    basicPersonnelLevelQueryAllEnabled,
    basicPersonnelLevelSave,
    basicpersonnelList,
    basicpersonnelDelete,
    basicpersonnelSave,
    basicpersonnelExport,
    storeSave,
    storeDetail,
    storeDelete,
    storeList,
    basicprojectList,
    basicprojectSave,
    basicprojectDeleteAll,
    basicprojectDelete,
    basicprojectExport,
    basicbankList,
    basicbanktSave,
    basicbankDelete,
    accountList,
    accountSave,
    accountDetail,
    accountDelete,
    basicinventoryList,
    basicinventoryQueryAll,
    basicinventorySave,
    basicinventoryDelete,
    accountUpdate,
    accountConfigSave,
    basicList,
    accountConfigDetail,
    accountServiceList,
    accountServiceSave,
    syncSubject,
    unitSave,
    unitDelete,
    unitList,
    basicInventoryExport,
    basicInventoryExportExcel,
    uniExport,
    basicPersonnelSelect,
    backExport,
    subjectAllList,
    basicprojectAll,
    allStore,
    allDepartment,
    allPersonnel,
    allSupplier,
    allProject,
    allBank,
    abconfigureassetList,
    abconfigureassetUpdate


}



// WEBPACK FOOTER //
// ./src/api/AccountManagementApi/accountManagement.js